import { useEffect, useState, useContext } from "react";
import ProjectBlobNarrow from "./ProjectBlobNarrow";
import { userContext } from '../../contexts/userContext';
import serverURL from "../../config/serverConfig";
import { ChartNoAxesGantt, Disc3, DiscAlbum, Search } from 'lucide-react';
import { Link } from "react-router-dom";

export const Projects = () => {
    const user_id = useContext(userContext);
    const [searchTerm, setSearchTerm] = useState("");
    const [allProjects, setAllProjects] = useState([]);

    const projectCategories = [
        { status: "Not Started", label: "Not Started", color: "#DC0000" },
        { status: "Awaiting Assets", label: "Awaiting Assets", color: "#FF3300" },
        { status: "In Progress", label: "In Progress", color: "#ff7700" },
        { status: "Awaiting Feedback", label: "Awaiting Feedback", color: "#ffb200" },
        { status: "Revising", label: "Revising", color: "#ffee00" },
        { status: "Mastering", label: "Mastering", color: "#B2DF00" },
        { status: "Delivering", label: "Delivering", color: "#46C408" },
        { status: "Complete", label: "Completed", color: "#00a116" }
    ];

    const [projectLists, setProjectLists] = useState(
        Object.fromEntries(projectCategories.map(c => [c.status, []]))
    );

    useEffect(() => {
        fetch(`${serverURL}getUserProjects`, {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ user_id: user_id[0] }),
        })
            .then(response => response.json())
            .then(jsonData => {
                setAllProjects(jsonData);
                console.log(jsonData)
            })
            .catch(error => {
                console.error("Error fetching projects:", error);
            });
    }, [user_id]);

    useEffect(() => {
        const temp = Object.fromEntries(projectCategories.map(c => [c.status, []]));

        const filtered = allProjects.filter(project => {
            const term = searchTerm.toLowerCase();
            return (
                project.client?.toLowerCase().includes(term) ||
                project.title?.toLowerCase().includes(term) ||
                project.status?.toLowerCase().includes(term)
            );
        });

        for (const project of filtered) {
            if (temp[project.status]) {
                temp[project.status].push(
                    <Link
                        to="/project"
                        state={{ project_id: project.project_id }}
                        key={project.project_id}
                    >
                        <ProjectBlobNarrow project={project} />
                    </Link>
                );
            }
        }

        setProjectLists(temp);
    }, [searchTerm, allProjects]);

    return (
        <div className="m-auto mt-6 px-10 max-w-[1200px] flex flex-col self-center">
            {/* Header + Filter */}
            <div className="flex flex-row justify-between">
                <Link to="createproject" id="newProjectLink" className="w-[200px]">
                    <button className="py-0 px-2 flex-left bg-[#ffee00] rounded-md uppercase font-semibold text-sm text-[black] hoverUp hover:text-[#666]">
                        + create new project
                    </button>
                </Link>
                <div className="float-right flex items-center gap-2">
                    {/* <ChartNoAxesGantt color="#ffee00" size={18}/> */}
                    <div className="relative">
                        <Search
                            color="#ffee00"
                            size={16}
                            className="absolute left-2 top-1/2 -translate-y-1/2 pointer-events-none"
                        />
                        <input
                            type="text"
                            placeholder="Filter projects..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="bg-[#111] border border-[#333] rounded-xl pl-8 pr-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-[#555] text-white"
                        />
                    </div>
                </div>

            </div>

            {/* ACTIVE PROJECTS */}
            <div className="mt-8 mb-4 w-full flex flex-col">
                <h3 className="flex items-center gap-1 font-medium">
                    <Disc3 color="#ffee00" size={16}/>ACTIVE PROJECTS
                </h3>
                <div className="hBar mt-[7px] mb-[10px]"></div>
                <div className="pt-2 grid gap-3 grid-flow-row grid-rows-3 grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
                    {projectCategories
                        .filter(c => c.status !== "Complete")
                        .map(c => (
                        <div
                            key={c.status}
                            className="min-w-[300px] max-w-[475px] rounded-xl bg-[#181818] pt-2 pb-3 px-3"
                        >
                            <h5 className="uppercase text-xs tracking-wider">{c.label}</h5>
                            <div className="hBar mt-[2px] mb-[10px]" style={{ backgroundColor: c.color }}></div>
                            <div className="flex flex-col gap-1">
                                {projectLists[c.status]}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* COMPLETED PROJECTS */}
            <div className="mt-10">
                <h3 className="flex items-center gap-1 font-medium">
                    <DiscAlbum color="#ffee00" size={18}/>COMPLETED PROJECTS
                </h3>
                <div className="hBar mt-[7px] mb-[10px]"></div>
                <div className="mt-4 flex flex-col gap-1 max-h-[40vh] overflow-auto max-w-xl px-2">
                    {projectLists["Complete"]}
                </div>
            </div>
        </div>
    );
};
